// Real ThemeStudios assets pulled from themestudios.in
// Logo: official branding folder. Boards: official portfolio folder.

const TS = "https://themestudios.in";

export const BRAND = {
  logoLight: `${TS}/assets/branding/ts-logo-light.webp`,
  logoDark: `${TS}/assets/branding/ts-logo-dark.webp`,
  whatsapp: "https://wa.me/918903205676",
  whatsappPhone: "+91 8903 205 676",
  email: "support@themestudios.in",
  city: "Madurai, Tamil Nadu",
};

export const BOARDS = {
  master: `${TS}/assets/portfolio/business-portfolio-2026.webp`,
  aboutCore: `${TS}/assets/portfolio/about-core-services.webp`,
  postersSocial: `${TS}/assets/portfolio/posters-social-pricing.webp`,
  reelsBranding: `${TS}/assets/portfolio/reels-branding-pricing.webp`,
  adsProfile: `${TS}/assets/portfolio/business-profile-ad-pricing.webp`,
  monthlyUniversal: `${TS}/assets/portfolio/universal-monthly-packages.webp`,
  clinicStartup: `${TS}/assets/portfolio/clinic-startup-packages.webp`,
  restaurantSalon: `${TS}/assets/portfolio/restaurant-salon-packages.webp`,
  constructionRetail: `${TS}/assets/portfolio/construction-retail-packages.webp`,
  education: `${TS}/assets/portfolio/education-packages-contact.webp`,
};

// Real case-study tiles using the actual studio boards
export const REAL_PORTFOLIO = [
  {
    slug: "posters-social-board",
    title: "Posters & Social Pricing Board",
    client: "ThemeStudios · 2026 catalog",
    tag: "Posters",
    year: "2026",
    img: BOARDS.postersSocial,
    blurb: "The actual ₹349–₹1,499 entry-point pricing board buyers see on the homepage.",
  },
  {
    slug: "reels-branding-board",
    title: "Reels, Branding & Identity",
    client: "ThemeStudios · Motion + Identity",
    tag: "Reels",
    year: "2026",
    img: BOARDS.reelsBranding,
    blurb: "Short-form video + logo + stationery grouped into one ₹999–₹12,999 ladder.",
  },
  {
    slug: "ads-profile-board",
    title: "Business Profile, Ads & Campaigns",
    client: "ThemeStudios · Ads Support",
    tag: "Ads",
    year: "2026",
    img: BOARDS.adsProfile,
    blurb: "Profiles, ad creatives, campaign setup — ₹499 to ₹5,999, ad spend separate.",
  },
  {
    slug: "monthly-universal-board",
    title: "Universal Monthly Packages",
    client: "ThemeStudios · Recurring Systems",
    tag: "Monthly",
    year: "2026",
    img: BOARDS.monthlyUniversal,
    blurb: "Starter → Full Support recurring ladder from ₹4,999 to ₹24,999 / month.",
  },
  {
    slug: "clinic-startup-board",
    title: "Clinic + Startup Packs",
    client: "Healthcare & Launch Brands",
    tag: "Industry",
    year: "2026",
    img: BOARDS.clinicStartup,
    blurb: "Trust-building monthly packs, healthcare branding, startup launch & growth.",
  },
  {
    slug: "restaurant-salon-board",
    title: "Restaurant + Salon Packs",
    client: "Food & Beauty Brands",
    tag: "Industry",
    year: "2026",
    img: BOARDS.restaurantSalon,
    blurb: "Food promos, offer pushes, menu branding, bridal & salon campaign packs.",
  },
  {
    slug: "construction-retail-board",
    title: "Construction + Retail Packs",
    client: "Real Estate & Local Shops",
    tag: "Industry",
    year: "2026",
    img: BOARDS.constructionRetail,
    blurb: "Builder branding, real-estate listings, festival sales, WhatsApp catalogs.",
  },
  {
    slug: "education-board",
    title: "Education & Training Packs",
    client: "Institutes & Training Centres",
    tag: "Industry",
    year: "2026",
    img: BOARDS.education,
    blurb: "Admission campaigns, institute branding, monthly education growth packs.",
  },
];
